import API from "../api/client";

// The notification settings and web push calls (api/notify). The "me" routes
// act on the signed-in user's own rows; the admin routes sit behind
// RouteAdminOnly on the server.

export function myNotificationSettingsGET() {
	return API.get("/me/notification_settings");
}

export function myNotificationSettingPUT(kind, push) {
	return API.patch("/me/notification_settings", { kind, push });
}

export function myPushSubscriptionPOST(subscription) {
	return API.post("/me/push_subscriptions", subscription);
}

export function myPushSubscriptionDELETE(id) {
	return API.delete("/me/push_subscriptions/" + id);
}

export function myPushTestPOST() {
	return API.post("/me/push_test");
}

export function userNotificationSettingsGET(userId) {
	return API.get("/admin/users/" + userId + "/notification_settings");
}

export function userNotificationSettingPUT(userId, kind, push) {
	return API.patch("/admin/users/" + userId + "/notification_settings", { kind, push });
}

export function userPushAccessPUT(userId, enabled, note) {
	return API.patch("/admin/users/" + userId + "/push_access", { enabled, note: note || "" });
}

export function userPushSubscriptionDELETE(userId, id) {
	return API.delete("/admin/users/" + userId + "/push_subscriptions/" + id);
}

export function userPushTestPOST(userId) {
	return API.post("/admin/users/" + userId + "/push_test");
}
